import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Navbar from "../../components/common/Layout/Navbar";
import "./Auth.css";

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { verifyEmail } = useAuth();
  const started = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    if (started.current) return;
    started.current = true;

    if (!token) {
      setError("This verification link is missing its token.");
      return;
    }

    verifyEmail(token)
      .then(() => navigate("/dashboard", { replace: true }))
      .catch((verificationError) => {
        setError(
          verificationError.message ||
            "Email verification failed. The link may have expired.",
        );
      });
  }, [navigate, searchParams, verifyEmail]);

  return (
    <>
      <Navbar variant="auth" />
      <main className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>Verify your email</h1>
            <p>
              {error
                ? "We could not verify this email address."
                : "Verifying your email address…"}
            </p>
          </div>
          {error ? (
            <div className="alert alert-error" role="alert">
              {error}
              <p>
                <Link to="/register">Create an account again</Link> or{" "}
                <Link to="/login">sign in</Link>.
              </p>
            </div>
          ) : (
            <div className="alert alert-success" role="status">
              Once verification succeeds, you can signin.
            </div>
          )}
        </div>
      </main>
    </>
  );
};

export default VerifyEmail;
